import { toast } from '@huspy/forge/shared';
import usePersistUser from '@modules/core/hooks/usePersistUser';
import paymentsApi from '@modules/payments/api';
import { CreateCheckoutSessionRequestDTO } from '@modules/payments/api/types';
import { useMutation } from '@tanstack/react-query';

const useCreateCheckoutSession = () => {
  const { user } = usePersistUser();

  const {
    data, error, mutateAsync, isPending,
  } = useMutation({
    mutationKey: ['paymentsCreateCheckoutSession'],
    mutationFn: (body: CreateCheckoutSessionRequestDTO) =>
      paymentsApi.createCheckoutSession(user?.brokerageId!, body),
    onError: (err) => {
      toast('error', { message: err.message });
    },
  });

  return {
    data,
    error,
    mutateAsync,
    isPending,
  };
};

export { useCreateCheckoutSession };
